import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes, FaLeaf } from "react-icons/fa";
import logo from '../assets/uploads/2018/10/logo-design-new-300x39.png';

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact Us" },
  { to: "/appointment", label: "Appointment" },
  { to: "/gallery", label: "Gallery" },
];

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <nav className="bg-white shadow sticky top-0 z-50">
      <div className="container mx-auto flex items-center justify-between px-4 py-3">
        <Link to="/" className="flex items-center gap-2 text-xl font-bold text-green-700">
          <img src={logo} alt="DivineWellness Logo" className="h-10 w-auto" />
        </Link>
        <div className="hidden md:flex gap-8">
          {navLinks.map(link => (
            <Link key={link.to} to={link.to} className="hover:text-green-600 font-medium">
              {link.label}
            </Link>
          ))}
        </div>
        <button className="md:hidden" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
          {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>
      </div>
      {menuOpen && (
        <div className="md:hidden bg-white border-t">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className="block px-4 py-3 border-b hover:bg-green-50"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}

export default Navbar;
